import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaUsers, 
  FaFileInvoiceDollar, 
  FaFileContract, 
  FaMoneyBillWave,
  FaBars,
  FaTimes,
  FaClipboardList,
  FaUser,
  FaDesktop,
  FaWhatsapp
} from 'react-icons/fa';
import '../../responsive.css';
import logoVermelha from '../../assets/logo-vermelha.png';
import { AuthContext } from '../../contexts/AuthContext';

const Sidebar = ({ collapsed, toggleSidebar }) => {
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mobileView, setMobileView] = useState(false);
  const [internalCollapsed, setInternalCollapsed] = useState(false);
  const { userFirebase } = useContext(AuthContext);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      setMobileView(width < 992);
      // No computador (>= 992px), sidebar começa aberta
      if (width >= 992) {
        setInternalCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // No computador (>= 992px), sidebar começa aberta
    if (windowWidth >= 992) {
      setInternalCollapsed(false);
    } else {
      setInternalCollapsed(collapsed);
    }
  }, [windowWidth, collapsed]);

  // Fechar sidebar automaticamente após clique em link no modo mobile
  const handleLinkClick = () => {
    if (mobileView) {
      toggleSidebar();
    }
  };

  const menuItems = [
    { path: '/dashboard', icon: <FaTachometerAlt />, text: 'Dashboard' },
    { path: '/clientes', icon: <FaUsers />, text: 'Clientes' },
    { path: '/equipamentos', icon: <FaDesktop />, text: 'Equipamentos' },
    { path: '/planos', icon: <FaClipboardList />, text: 'Planos' },
    { path: '/pedidos', icon: <FaFileInvoiceDollar />, text: 'Pedidos' },
    { path: '/contas', icon: <FaMoneyBillWave />, text: 'Contas' },
    { path: '/teamzap', icon: <FaWhatsapp />, text: 'TeamZap' },
    ...(userFirebase?.permission === 'administrador'
      ? [{ path: '/createuser', icon: <FaUser />, text: 'Criar Usuário' }]
      : [])
  ];

  return (
    <div className={`sidebar ${internalCollapsed ? 'collapsed' : ''} ${mobileView && !internalCollapsed ? 'show' : ''}`}>
      <div className="sidebar-header">
        <Link to="/dashboard" className="sidebar-logo">
          {/* {!internalCollapsed && <span>Maxtra Mídia</span>} */}
          {!internalCollapsed && <img src={logoVermelha} alt="Logo Maxtra Mídia" className="img-logo" />}
        </Link>
        <button
          className="sidebar-toggle"
          onClick={() => {
            if (mobileView) {
              setInternalCollapsed(!internalCollapsed);
              toggleSidebar();
            } else {
              setInternalCollapsed(!internalCollapsed);
            }
          }}
        >
          {internalCollapsed ? <FaBars /> : <FaTimes />}
        </button>
      </div>

      <ul className="sidebar-menu">
        {menuItems.map((item) => (
          <li key={item.path} className="sidebar-menu-item">
            <Link
              to={item.path}
              className={`sidebar-menu-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={handleLinkClick}
            >
              <span className="sidebar-menu-icon">{item.icon}</span>
              <span className="sidebar-menu-text">{item.text}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
